var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',{attrs:{"type":"image/webp"}},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt,"loading":"lazy","role":"presentation","decoding":"async","fetchpriority":"high"}})])}
var staticRenderFns = []

export { render, staticRenderFns }